import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.tsx';
import { MixpanelPageTracker } from './components/analytics/MixpanelPageTracker';
import { OpenPanelPageTracker } from './components/analytics/OpenPanelPageTracker';
import { ProductionGoogleAnalytics } from './components/analytics/ProductionGoogleAnalytics';
import './index.css';
import { registerDeployRefreshListeners } from './utils/deployRefresh';

registerDeployRefreshListeners();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ProductionGoogleAnalytics />
        <MixpanelPageTracker />
        <OpenPanelPageTracker />
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
